<div class="modal-participate" *ngIf="isParticipate">
  <form class="container" [formGroup]="form">
    <div class="participate-form">
      <!-- HEADER -->
      <div class="title-modal">
        <div class="participate-header">
          <p>Inscrever-se na campanha</p>
          <button class="btn btn-close" (click)="closeModal()">
            <img src="../../../assets/svgs/close_btn.svg" alt="Fechar">
          </button>
        </div>
        <p>Preencha as informações abaixo para participar da campanha.</p>
      </div>

      <p class="information" *ngIf="campaign.product_name">
        <span class="title">Produto: </span>
        <ng-container *ngIf="campaign.product_alias">{{ campaign.product_alias }}</ng-container>
        <ng-container *ngIf="!campaign.product_alias">{{ campaign.product_name }}</ng-container>
        -
        <a class="link" *ngIf="campaign.product_sku" target="_blank" href="/produtos/ficha/{{campaign.product_sku}}">Ficha do imóvel</a>
      </p>
  
      <!-- VALOR INVESTIDO -->
      <div class="input-controll">
        <app-input label="Quanto você gostaria de investir (R$)?" formControlName="value_invest" 
        placeholder="R$" isPrice="true" (input)="removeCaracter($event)"
        (change)="updateAllValues($event.target.value);"
        [messageError]="'Valor mínimo da campanha: ' + (minValue | currency:'BRL') " [error]="is_price"></app-input>
        <small *ngIf="!is_price">
          Valor mínimo da campanha: {{ (minValue | currency:'BRL') }}
          <img src="assets/svgs/question_mark.svg" alt="Dúvidas" (click)="showMinValueDialog()">
        </small>
      </div>
  
      <hr class="line">
  
      <!-- PARTICIPANTES DA CAMPANHA -->
      <div class="participate-user">
        <p class="title">Participantes</p>
        <div class="form-controll">
          <div class="list-controll" *ngFor="let item of participants.controls; let i = index; let last = last">
            <div class="form-array" [formGroup]="item">
              <app-lead-autocomplete 
                field="user_nickname" 
                class="user-name-controll" 
                [id]="i" 
                [data]="item"
                [campaignId]="campaign.id"
                [participants]="participants.value"
                (fieldUser)="getUser($event, i)">
              </app-lead-autocomplete>
              <div class="investiments">
                <div class="container-cp margin-right">
                  <app-input id="lead-user-value-{{i}}"
                    class="user-percent full"
                    label="Investimento (R$)"
                    formControlName="participation_value"
                    placeholder="R$"
                    isPrice="true"
                    (change)="calculateNumbers($event.target.value, i, 'participation_percentage')"
                    (input)="removeCaracter($event)"
                    [error]="participantFieldError[i] || isValueError"
                    [messageError]="participantFieldError[i] || valueErro"></app-input>
                </div>
                <div class="container-cp">
                  <app-input class="user-percent"
                    id="lead-user-percent-{{i}}"
                    [ngClass]="{'full': i === 0}"
                    (change)="calculateNumbers($event.target.value, i, 'participation_value')"
                    (input)="removeCaracter($event)"
                    label="% de investimento"
                    formControlName="participation_percentage"
                    placeholder="%"
                    [messageError]="participantFieldError[i] || messageErro"
                    [error]="participantFieldError[i] || isError"></app-input>
                </div>
              </div>
              <button class="btn-clear-user" [ngClass]="{ 'msg-error': isError, 'value-error': isValueError }" *ngIf="participants.length > 1" (click)="showDialog(i)">
                <div class="icon-name">
                  <img src="assets/svgs/i_closed_red.svg" alt="Excluir">
                  <p>Remover</p>
                </div>
              </button>
            </div>
            <hr class="line" *ngIf="participants.length > 1 && !last">
          </div>
        </div>
        <div class="add-participants">
          <lib-button-secondary 
          (onclick)="newParticipate()"
          [isDisabled]="participants.length >= maxParticipants">
            Adicionar corretor
          </lib-button-secondary>
          <p>Máximo: {{ maxParticipants }} participantes</p>
        </div>
      </div>
  
      <hr class="line">
      
      <!-- LISTA  -->
      <div class="dropdown-text-list" *ngIf="isSegmentationAvailable">
        <p>Qual tipo de segmentação você deseja para sua campanha?</p>
        <mat-radio-group [(ngModel)]="selectedStatus" formControlName="type_segmentation">
          <mat-radio-button class="item" *ngFor="let item of listRadioButton" [value]="item" (change)="changeValue(item)">
            <span>{{ item.title }}</span>
          </mat-radio-button>
        </mat-radio-group>

      </div>
  
    </div>
    <div class="footer-modal">
      <lib-button-tertiary class="btn" 
      (click)="closeModal()">
        Cancelar
      </lib-button-tertiary>
      <lib-button-primary class="btn" 
      [isDisabled]="!form.valid" 
      (click)="nextLevel()">
        Próximo
      </lib-button-primary>
    </div>
  </form>
</div>

<app-model-summary *ngIf="isSummary" [isSummary]="isSummary" [formSummary]="form" (closeSummary)="closeFullModal()" (backLevel)="backLevel($event)" (finished)="finished.emit(true)"></app-model-summary>
